import {
    faCircleCheck,
    faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons"

import {
    COMMON_ONE_VERIFY_PAYER_STATUS_CONFIG,
    PayerStatus,
} from "@common-shared/config/oneVerify/oneVerifyPayerStatus.config"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"

import { IPayerStatusConfig } from "../types/payerStatus.types"

export enum PayerStatusRange {
    ONE_HOUR = "1h",
    FOUR_HOURS = "4h",
    ONE_DAY = "1d",
    ONE_WEEK = "1w",
}

export const PAYER_STATUS_CONFIG = {
    ...COMMON_ONE_VERIFY_PAYER_STATUS_CONFIG,

    defaultRange: PayerStatusRange.ONE_DAY,

    // Data that couldn't be refreshed for this long is shown as out of date
    staleAfterMs: 5 * 60 * 1000,

    // Timeline shows this many payers until expanded
    timelineMaxPayers: 6,

    rangesDurationMs: {
        [PayerStatusRange.ONE_HOUR]: 60 * 60 * 1000,
        [PayerStatusRange.FOUR_HOURS]: 4 * 60 * 60 * 1000,
        [PayerStatusRange.ONE_DAY]: 24 * 60 * 60 * 1000,
        [PayerStatusRange.ONE_WEEK]: 7 * 24 * 60 * 60 * 1000,
    } satisfies Record<PayerStatusRange, number>,

    rangeLabels: {
        [PayerStatusRange.ONE_HOUR]: "1 hour",
        [PayerStatusRange.FOUR_HOURS]: "4 hours",
        [PayerStatusRange.ONE_DAY]: "1 day",
        [PayerStatusRange.ONE_WEEK]: "1 week",
    } satisfies Record<PayerStatusRange, string>,

    rangeShortLabels: {
        [PayerStatusRange.ONE_HOUR]: "1 hr",
        [PayerStatusRange.FOUR_HOURS]: "4 hr",
        [PayerStatusRange.ONE_DAY]: "1 day",
        [PayerStatusRange.ONE_WEEK]: "1 wk",
    } satisfies Record<PayerStatusRange, string>,

    statuses: {
        [PayerStatus.OPERATIONAL]: {
            label: "Operational",
            badgeLabel: "Operational",
            description:
                "No issues detected. If you’re still seeing problems, contact support.",
            icon: faCircleCheck,
            color: NIRVANA_COLORS.brand.green,
            badgeClassName: "bg-brand-greenLight border-brand-green2",
        },
        [PayerStatus.ISSUE_DETECTED]: {
            label: "Issue detected",
            badgeLabel: "Ongoing issue detected",
            description:
                "We’ve detected elevated errors with this payer. We’re aware and monitoring. Your requests may be delayed or fail.",
            icon: faTriangleExclamation,
            color: NIRVANA_COLORS.brand.orange,
            badgeClassName: "bg-brand-orange010 border-brand-orange",
        },
    } satisfies Record<PayerStatus, IPayerStatusConfig>,

    timeFormat: "h:mm A",
    dayFormat: "MMM D",
    dayTimeFormat: "MMM D, h:mm A",
}
